// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120731/js/" + chunkId + "." + {"44":"d8a6b3de","225":"27acacf5","481":"81b9b06b","486":"6e90dd4b","770":"4fc58dac"}[chunkId] + ".0.35109650414443194.chunk.js";
};